var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated slideInUp","leave-active-class":"animated slideOutDown"}},[_c('AlertSheet',{on:{"submit":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"h2 my-4"},[_vm._v("เสียใจด้วย"),_c('br'),_vm._v("สิ้นสุดการจับรางวัลแล้ว")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }